export default "__VITE_ASSET__CxvKPtSe__"